import { CommonModule } from '@angular/common';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AirportLookupModule } from '../../common/airport-lookup/airport-lookup.module';
import { NgcCommonModule } from '../../common/common.module';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
import { DateSelectionModule } from '../../common/date-selection/date-selection.module';
import { ErrorHandlerModule } from '../../common/error-handler/error-handler.module';
import { NgcStoreModule } from '../../store/store.module';
// This Module's Components
import { NavigationFlightStatusComponent } from './navigation-flight-status.component';

@NgModule({
  imports: [
    NgcCommonModule,
    DataLayerModule,
    ReactiveFormsModule,
    FormsModule,
    AirportLookupModule,
    ErrorHandlerModule,
    DateSelectionModule,
    CommonModule,
    NgcStoreModule
  ],
  declarations: [NavigationFlightStatusComponent],
  exports: [NavigationFlightStatusComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavigationFlightStatusModule {}
